export default function Section5() {
    return (
        <div id="section-5">
            <div className="title mt-2">
                <span className="text-blue-500">Effortless</span> PDF Interactions
            </div>
            <div className="text-center w-full">
                Quickly summarize, compare, and ask questions about any PDF.
            </div>

            <div className="content">
                <div className="col-2 col">
                    <div className="box">
                        <img src="/assets/LandingSection5Col1.svg"
                        style={{
                            "width": "100%"
                        }}></img>
                        <div className="sub-title">Summarize PDFs</div>
                        <div className="sub-description">
                            Condense academic articles, research papers, or reports into key takeaways without reading the entire document.
                        </div>
                    </div>
                </div>
                <div className="col-2 col">
                    <div className="box">
                    <img src="/assets/LandingSection5Col2.svg"
                    style={{
                        "width": "100%"
                    }}></img>
                    <div className="sub-title">Side-by-Side View</div>
                    <div className="sub-description">
                        View the chat and PDF together. Linked answers make it easy to verify details or dive deeper into the original content.
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}